"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pagination = exports.PageLink = void 0;
var _react = _interopRequireDefault(require("react"));
var _ChevronLeftIcon = _interopRequireDefault(require("@artsy/icons/ChevronLeftIcon"));
var _ChevronRightIcon = _interopRequireDefault(require("@artsy/icons/ChevronRightIcon"));
var _Flex = require("../Flex");
var _Text = require("../Text");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Box = require("../Box");
var _excluded = ["getHref", "hasNextPage", "onClick", "onNext", "pageCursors"],
  _excluded2 = ["getHref", "onClick", "pageCursor"],
  _excluded3 = ["disabled", "getHref", "onClick", "page", "children"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var PageLink = _styledComponents.default.a.withConfig({
  displayName: "Pagination__PageLink",
  componentId: "sc-1r2jw01-0"
})(["text-decoration:none;&:hover{text-decoration:underline;}", ""], _Box.boxMixin);
exports.PageLink = PageLink;
/** Pagination */
var Pagination = function Pagination(_ref) {
  var getHref = _ref.getHref,
    hasNextPage = _ref.hasNextPage,
    onClick = _ref.onClick,
    onNext = _ref.onNext,
    _ref$pageCursors = _ref.pageCursors,
    around = _ref$pageCursors.around,
    first = _ref$pageCursors.first,
    last = _ref$pageCursors.last,
    previous = _ref$pageCursors.previous,
    rest = _objectWithoutProperties(_ref, _excluded);
  var handlePrevClick = function handlePrevClick(event) {
    if (previous) {
      onClick && onClick(previous.cursor, previous.page, event);
    }
  };
  var handleNextClick = function handleNextClick(event) {
    onNext && onNext(event, nextPage);
  };
  var nextPage = ((previous === null || previous === void 0 ? void 0 : previous.page) || 0) + 2;
  return /*#__PURE__*/_react.default.createElement(_Text.Text, _extends({
    as: "nav",
    "aria-label": "Pagination",
    display: "flex",
    variant: "sm",
    lineHeight: 1,
    alignItems: "center",
    justifyContent: "space-between"
  }, rest), /*#__PURE__*/_react.default.createElement(NextPrevButton, {
    "data-testid": "prev",
    "aria-label": "Previous",
    getHref: getHref,
    onClick: handlePrevClick,
    page: previous === null || previous === void 0 ? void 0 : previous.page,
    disabled: !previous,
    pr: 0.5
  }, /*#__PURE__*/_react.default.createElement(_ChevronLeftIcon.default, {
    mr: 0.5,
    height: 12,
    width: 12
  }), /*#__PURE__*/_react.default.createElement("span", null, "Prev")), /*#__PURE__*/_react.default.createElement(_Flex.Flex, null, first && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Page, {
    onClick: onClick,
    pageCursor: first,
    getHref: getHref
  }), /*#__PURE__*/_react.default.createElement(_Flex.Flex, {
    alignItems: "center",
    p: 0.5,
    color: "black60"
  }, "\u2026")), around.map(function (pageCursor) {
    return /*#__PURE__*/_react.default.createElement(Page, {
      getHref: getHref,
      key: pageCursor.page,
      onClick: onClick,
      pageCursor: pageCursor
    });
  }), last && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Flex.Flex, {
    alignItems: "center",
    p: 0.5,
    color: "black60"
  }, "\u2026"), /*#__PURE__*/_react.default.createElement(Page, {
    onClick: onClick,
    pageCursor: last,
    getHref: getHref
  }))), /*#__PURE__*/_react.default.createElement(NextPrevButton, {
    "data-testid": "next",
    getHref: getHref,
    onClick: handleNextClick,
    page: nextPage,
    disabled: !hasNextPage,
    pl: 0.5
  }, /*#__PURE__*/_react.default.createElement("span", null, "Next"), /*#__PURE__*/_react.default.createElement(_ChevronRightIcon.default, {
    ml: 0.5,
    height: 12,
    width: 12
  })));
};
exports.Pagination = Pagination;
Pagination.displayName = "Pagination";
var Page = function Page(_ref2) {
  var getHref = _ref2.getHref,
    onClick = _ref2.onClick,
    _ref2$pageCursor = _ref2.pageCursor,
    cursor = _ref2$pageCursor.cursor,
    isCurrent = _ref2$pageCursor.isCurrent,
    page = _ref2$pageCursor.page,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  var handleClick = function handleClick(event) {
    onClick && onClick(cursor, page, event);
  };
  var href = page && typeof getHref !== "undefined" ? getHref(page) : "";
  return /*#__PURE__*/_react.default.createElement(PageLink, _extends({
    href: href,
    onClick: handleClick,
    borderRadius: 2,
    display: "flex",
    alignItems: "center",
    p: 0.5
  }, isCurrent ? {
    color: "black100",
    "aria-current": "page"
  } : {
    color: "black60"
  }, rest), page);
};
Page.displayName = "Page";
var NextPrevButton = function NextPrevButton(_ref3) {
  var disabled = _ref3.disabled,
    getHref = _ref3.getHref,
    onClick = _ref3.onClick,
    page = _ref3.page,
    children = _ref3.children,
    rest = _objectWithoutProperties(_ref3, _excluded3);
  var href = !disabled && page && typeof getHref !== "undefined" ? getHref(page) : "";
  if (disabled) {
    return /*#__PURE__*/_react.default.createElement(_Flex.Flex, _extends({
      display: "flex",
      alignItems: "center",
      color: "black30",
      py: 0.5
    }, rest), children);
  }
  return /*#__PURE__*/_react.default.createElement(PageLink, _extends({
    href: href,
    onClick: onClick,
    display: "flex",
    alignItems: "center",
    py: 0.5,
    style: !disabled ? {
      opacity: 1,
      pointerEvents: "inherit"
    } : {
      opacity: 0.1,
      pointerEvents: "none"
    }
  }, rest), children);
};
NextPrevButton.displayName = "NextPrevButton";
//# sourceMappingURL=Pagination.js.map